<template>
<div>
  <div
    class="desktop"
    :style="{'top': fixCartTop+'px'}">
    <div class="thumbnail">
      <img :src="thumbnail">
    </div>
    <div
      v-if="showSpecBox"
      class="chooseExtra">
      <span>選擇商品規格</span>
    </div>
    <div class="Quantity">
      <button @click="minus()" class="IconMin"></button>
      <input type="text" :value="cartBuyQuantity" class="QuantityNum" readonly="true" />
      <button @click="plus()" class="IconPlus"></button>
    </div>
    <div
      v-if="showAdditional"
      class="chooseExtra">
      <span>選擇加購商品</span>
    </div>
    <div class="ButtonBar">
      <a v-if="!info.isSoldOut" @click="goShop()" title="選購" class="Btn">
        <i class="IconCar"></i>選購
      </a>
      <a v-else title="已售完" class="Btn soldout">
        <i class="IconCar"></i>已售完
      </a>
    </div>
    <div class="btnWrapper">
      <button @click="goTocatelog()">TOP <span class="arrow"></span></button>
    </div>
  </div>

  <div class="mweb">
    <div class="Flex">
      <div
        v-if="!showSpecBox && !showAdditional"
        class="Quantity">
        <button @click="minus()" class="IconMin"></button>
        <input type="text" :value="cartBuyQuantity" class="QuantityNum" readonly="true" />
        <button @click="plus()" class="IconPlus"></button>
      </div>
      <div class="ButtonBar">
        <a v-if="!info.isSoldOut" @click="goShop()" title="選購" class="Btn">
          <i class="IconCar"></i>選購
        </a>
        <a v-else title="已售完" class="Btn soldout">
          <i class="IconCar"></i>已售完
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'singleBuyItem',
  data() {
    return {
      showBuyitemMulti: false,
      cartData: [],
      showSpecBox: false,
      showAdditional: false,
      cartBuyQuantity: 1,
      nowSelectedSpec: null,
      nowSelectedSpecIdx: 0,
      nowSelectedSpecName: "",
      fixCartTop: 0
    }
  },
  props: {
    info: {
      type: Object,
      default: () => null
    }
  },
  created() {
    this.parseProductDetail()

    const yGap = 55
    window.onscroll = () => {
      this.fixCartTop = window.scrollY >= yGap ? window.scrollY - yGap : 0;
    };
  },
  methods: {
    parseProductDetail() {
      for (let i in this.info.variants) {
        if (!this.info.variants[i].isSoldOut) {
          this.nowSelectedSpec = this.info.variants[i].id;
          this.nowSelectedSpecIdx = parseInt(i);
          this.nowSelectedSpecName = this.info.variants[i].name;
          break;
        }
      }
      if (this.info.isSoldOut) {
        this.cartBuyQuantity = 0
        return
      }
      if (this.info.variants.length > 1) {
        this.showSpecBox = true;
      }
      if (this.info.additional && this.info.additional.length > 0) {
        this.showAdditional = true;
        this.$emit('hasAdditional', this.info, this.info.cid)
      }

      this.$emit("setCartType", this.info.cart_type);
    },
    minus() {
      if (this.info.isSoldOut) return
      this.cartBuyQuantity =
        this.cartBuyQuantity === 1 ? 1 : (this.cartBuyQuantity -= 1);
      this.$emit('updateCartBuyQuantity', this.cartBuyQuantity)
    },
    plus() {
      if (this.info.isSoldOut) return
      const ele = this.info.variants[this.nowSelectedSpecIdx];
      const purchase_qty = ele.qtyMax === 999 ? ele.qty : ele.qtyMax;
      this.cartBuyQuantity =
        this.cartBuyQuantity < purchase_qty ?
        (this.cartBuyQuantity += 1) :
        purchase_qty;
      this.$emit('updateCartBuyQuantity', this.cartBuyQuantity)
    },
    goShop() {
      if (this.showSpecBox || this.showAdditional) {
        this.$emit('openBuyItem')
        return
      }

      // 追蹤碼設定
      const chaId = document.cookie.match(/CHANNEL_ID0=([^;]+)/i);
      let channelId;
      if (chaId && chaId[1] && chaId[1] !== 'fetmc_appbonus') {
        channelId = chaId[1];
      }

      const o = this.info;
      let apiPayload = {
        channelId3: channelId,
        giftList: [],
        increaseList: [],
        productId: o.pid,
        quantity: +this.cartBuyQuantity,
        specId: +this.nowSelectedSpec,
        subProductList: []
      };
      this.$emit("addToCart", apiPayload);
    },
    goTocatelog() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    }
  },
  computed: {
    thumbnail() {
      return this.info.images[0].replace('-uat2', '')
    }
  },
}
</script>

<style lang="scss" scoped>
.desktop {
  z-index: 1;
  position: absolute;
  top: 0;
  right: -140px;
  width: 120px;
  min-height: 234px;
  border-radius: 10px;
  background-color: #fff;
  transition: .7s;
  transform: translateZ(0);

  .thumbnail {
    padding: 15px 20px 0;

    img {
      width: 80px;
      height: 80px;
      border-radius: 10px;
    }
  }

  .chooseExtra {
    padding: 15px 5px 5px;
    text-align: center;

    span {
      padding: 5px 10px;
      background-color: #f4f4f4;
      font-size: 14px;
      border-radius: 10px;
    }
  }

  .Quantity {
    padding: 15px 5px 0;
    display: flex;
    justify-content: space-evenly;

    button {
      display: inline-block;
    }

    .QuantityNum {
      vertical-align: top;
    }
  }

  .ButtonBar {
    padding-top: 15px;
  }

  .btnWrapper {
    padding-top: 15px;

    button {
      border-top: 1px solid #fff;
      background-color: #3c3c3c;
      padding: 10px 0;
      font-size: .875rem;
      cursor: pointer;
      width: 100%;
      color: #fff;
      border-radius: 0 0 10px 10px;
      z-index: -1;

      span.arrow {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAYAAADkgu3FAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGqADAAQAAAABAAAAGAAAAAA2CeVqAAABTklEQVRIDe2Uu0oDYRCF12tULHwbEUIEQbDwEbSwsEghaEIQsVCwsUghWOQFAgkpIoKFIAgi+DwqXgtdvwnZZTL77w3SuT8c9szMOWfCn2w8rzjFDeS9Ad/3F8EVeAVNMJE3I1VP6AJ4APq0KMa3jLB5cK83KH6Z+imzCAicA3cq2EUvsmTFakgsgVuT/Ex9Cn5MvxkblDQgZBbcmLAX6mXx8dwGdtl5UmZkRsAMuAb6yC9tRYupd8CvFsHPtCaWI5wGfWN+oy67TPR3gV124tKGPQxToAf0eadYDUUOwryqDUN+7JAO7lyWdIzhg3rNaTBNdHvGK+XhiIzGJGjLRJ1P+PqIMKVAf6D8Aa2HNjpbQXf4/OK5EQpyEHwNkyVlZRAB2VfDb/hmjuyIFP+RyhNaDRbJn2UXPIFM30kk3TTIqQF5uR/BkhkX5X+/gT+hti6KFYH1AwAAAABJRU5ErkJggg==');
        width: 12px;
        height: 12px;
        display: inline-block;
        background-repeat: no-repeat;
        background-size: contain;
        transition: .3s;

        &.open {
          transform: rotate(180deg);
        }
      }
    }
  }
}

.mweb {
  display: none;
}

@media (max-width: 768px) {
  .desktop {
    display: none;
  }

  .mweb {
    display: block;
    z-index: 1;
    position: fixed;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    height: 60px;
    padding: 10px 5px;
    border-top: 1px solid #e0e0e0;
    background-color: #fff;

    .Flex {
      div {
        flex: 1 1 50%;
        align-items: center;
        justify-content: center;
      }
    }

    .ButtonBar {
      a {
        height: 26px;
      }
    }
  }
}
</style>
